import React from 'react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {ITranslationService} from "../../services/translation/translation.service.interface";
import {UserInfo} from "../user-info/user-info.component";
import {WelcomeUserBox} from "./boxes/welcome-user.box";
import {WelcomeGreetingBox} from "./boxes/welcome-greeting.box";
import {WelcomeUserInfoBox} from "./boxes/welcome-user-info.box";
import { UserData } from '../../services/sdk/sdk.service.interface';

@observer
export class WelcomeUser extends OrbitComponent {
  render() {
    const {translation, userMenu:{greeting}} = this.services;
    const {showUserTitle, showFirstName, showLastName} = this.services.configuration.data.drawer.welcomeMessage;

    return (
      <WelcomeUserBox className="cy-welcome-user-menu-title">
        <WelcomeGreetingBox>{translation.translate(greeting)}</WelcomeGreetingBox>
        <WelcomeUserInfoBox>
          {this._renderUserTitle(showUserTitle, translation)}
          {this._renderUserInfo('firstName', showFirstName)}
          {this._renderUserInfo('lastName', showLastName)}
        </WelcomeUserInfoBox>
      </WelcomeUserBox>
    );
  }

  private _renderUserTitle(isEnabled: boolean, translator: ITranslationService) {
    if(!isEnabled)
      return null;

    const userGenderTitle = this.services.user.genderTitle;
    return <span>{translator.translate(userGenderTitle)}</span>
  }

  private _renderUserInfo(infoType: keyof UserData, isEnabled: boolean) {
    if(!isEnabled)
      return null;

    return <UserInfo selectedUserInfo={infoType} />;
  }
}
